/**
 * @member {string} comment
 */
export class UpdateDTO {
  constructor ({ comment = null }) {
    let properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    Object.defineProperty(this, 'comment', Object.assign({ value: comment }, properties));
    Object.freeze(this);
  }

  comment;
}
